import {doFetch} from "vimmi-web-utils/cjs/doFetch";
import Config from "./config";
import {formatDate} from "vimmi-web-utils/cjs/formatDate";
import loggers from "vimmi-player";

export class Channels {
    constructor() {
        this.playbackTemplate = 'https://redirector.ais-vidnt.com/live/ais/{{mid}}/hls/metadata.xml?origin=anevia&cdn=redfox-olympic-https&https_streaming=true&chunkHttps=true'
        this.channels = {};
    }

    async getScreenChannels() {
        if (Object.keys(this.channels).length) {
            return this.channels;
        }
        let screen = await doFetch(`https://${Config.get('backend')}/screen/exembed/`);
        if (screen.items.length) {
            let section = await doFetch(`https://${Config.get('backend')}${screen.items[0].link}`);
            // return section
            this.channels = {};
            section.items.map(channel => {
                channel.playback_url = this.playbackTemplate.replace('{{mid}}', channel.mid);
                this.channels[channel.id] = channel
            });
            return this.channels;
        }

    }

    async getChannels() {
        if (Object.keys(this.channels).length) {
            return this.channels;
        }
        let channels = await doFetch(`/${Config.get('env')}-channels.json`);
        return Promise.all(Object.keys(channels).map((id) => {
            return doFetch(`https://${Config.get('backend')}/get_item/${id}/?d=web`)
        })).then((resp) => {
            resp.map((channel) => {
                this.channels[channel.head.id] = {...channel.head, ...channels[channel.head.id]};
            })
            return this.channels;
        });
    }


    filter(amsChannels, ids) {
        return amsChannels.filter((channel) => {
            return ids.includes(channel.id);
        })
    }
}

const channelsSrv = new Channels();
export default channelsSrv;
